import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { SetCurrentCodeSection } from '../shared/navigation.state';
import { TNRService } from '../shared/services/tnr.service';
import { EvenementTNR } from '../shared/constants/evenement-tnr.enum';

@Component({
  selector: 'app-propriete',
  templateUrl: './propriete.component.html',
  standalone: false
})
export class ProprieteComponent implements OnInit {
  @Select(state => state.propriete.currentPage)
  currentPage$: Observable<string>;
  currentPage: string;

  constructor(private readonly _store: Store, private readonly _tnrService: TNRService) {}

  ngOnInit() {
    this._store.dispatch(new SetCurrentCodeSection('PROP'));

    this.currentPage$.subscribe(page => {
      this.currentPage = page;
    });

    this._tnrService.saveTNREvent(EvenementTNR.PREAUT_NON_COMPLETEE);
  }
}
